import { useEffect } from "react";
import { connect } from "react-redux";
import { RegistrationInputDetailsType } from "../../../../commonTypes/clientDirectoryTypes";
import {
  getGstInfoType,
  verifyPanType,
  verifyTanType,
} from "../../../../commonTypes/serviceTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import { RootState } from "../../../../redux/rootReducers";
import {
  getGstInfoAction,
  resetGstDetails,
  resetPanVerifyData,
  resetServicesSucces,
  resetTanVerifyData,
  verifyPanAction,
  verifyTanAction,
} from "../../../../redux/services";
import {
  PanVerifyType,
  TanVerifyType,
} from "../../../../redux/services/serviceTypes";
import { Loader } from "../../../commons";
import GstDetails from "./GstDetails";
import LabourLaw from "./LabourLaw";
import Others from "./Others";
import RegisteredUnder from "./RegisteredUnder";
import RegistrationDetails from "./RegistrationDetails";

type AppProps = {
  token: string | null;
  clientAadharUniqueCheckFetching: boolean;
  clientPanUniqueCheckFetching: boolean;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  registrationsInputDetails: RegistrationInputDetailsType;
  setRegistrationsInputDetails: (data: any) => void;
  gstDetails: any;
  gstFetching: boolean;
  singleClientDirectory: any;
  gstSuccess: number | null;
  dispatchGstDetailsAction: (data: getGstInfoType) => void;
  handleClientPanUniqueCheck: (data: any) => void;
  handleClientAadharUniqueCheck: (data: any) => void;
  dispatchResetGstDetails: () => void;
  dispatchResetServicesSucces: () => void;
  handleClientDirectoryFormSubmit: () => void;
  handleGoBack: () => void;
  dispatchResetClientAadharUniqueCheckMessage: () => void;
  dispatchResetClientPanUniqueCheckMessage: () => void;
  isDisabled?: boolean;
  isViewClientPresent?: boolean;
  panVerifyDetails: PanVerifyType | null;
  tanVerifyDetails: TanVerifyType | null;
  dispatchVerifyPanAction: (data: verifyPanType) => void;
  dispatchVerifyTanAction: (data: verifyTanType) => void;
  dispatchResetPanVerifyData: () => void;
  dispatchResetTanVerifyData: () => void;
};
const RegistrationsTab = ({
  token,
  gstFetching,
  gstSuccess,
  registrationsInputDetails,
  setRegistrationsInputDetails,
  dispatchGstDetailsAction,
  gstDetails,
  dispatchResetGstDetails,
  dispatchResetServicesSucces,
  handleClientDirectoryFormSubmit,
  handleGoBack,
  singleClientDirectory,
  handleClientPanUniqueCheck,
  handleClientAadharUniqueCheck,
  clientAadharUniqueCheckFetching,
  clientPanUniqueCheckFetching,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  dispatchResetClientPanUniqueCheckMessage,
  dispatchResetClientAadharUniqueCheckMessage,
  isDisabled,
  isViewClientPresent,
  panVerifyDetails,
  tanVerifyDetails,
  dispatchVerifyPanAction,
  dispatchVerifyTanAction,
  dispatchResetPanVerifyData,
  dispatchResetTanVerifyData,
}: AppProps) => {
  useEffect(() => {
    dispatchResetServicesSucces();
    // dispatchResetPanVerifyData();
    // dispatchResetTanVerifyData();
  }, []);

  const handleGstDetailsChange = (e: any) => {
    setRegistrationsInputDetails((prev: any) => {
      return {
        ...prev,
        gstDetails: {
          ...prev.gstDetails,
          [e.target.name]: e.target.value,
        },
      };
    });
  };

  useEffect(() => {
    if (gstDetails) {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          gstDetails: {
            ...prev.gstDetails,
            gstNumber: gstDetails?.gstin,
            legalName: gstDetails?.legal_name_of_business,
            tradeName: gstDetails?.trade_name,
            registrationType: gstDetails?.registration_type,
            registrationDate: gstDetails?.registration_date
              ?.split("/")
              .join("-"),
            constitutionOfBusiness: gstDetails?.constitution_of_business,
            companyStatus: gstDetails?.status,
          },
        };
      });
    }
  }, [gstDetails]);

  useEffect(() => {
    if (panVerifyDetails?.pan) {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            panDetails: panVerifyDetails,
          },
        };
      });
    } else {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            panDetails: null,
          },
        };
      });
    }
  }, [panVerifyDetails]);

  useEffect(() => {
    if (tanVerifyDetails?.nameOrgn) {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            tanDetails: tanVerifyDetails,
          },
        };
      });
    } else {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            tanDetails: null,
          },
        };
      });
    }
  }, [tanVerifyDetails]);

  const getPanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetPanVerifyData();
    if (registrationsInputDetails?.registrationDetails?.pan && token) {
      const finalData = {
        token,
        panNo: registrationsInputDetails?.registrationDetails?.pan,
      };
      dispatchVerifyPanAction?.(finalData);
    }
  };

  const getTanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetTanVerifyData();
    if (registrationsInputDetails?.registrationDetails?.tan && token) {
      const finalData = {
        token,
        tanNo: registrationsInputDetails?.registrationDetails?.tan,
      };
      dispatchVerifyTanAction?.(finalData);
    }
  };

  const getGstDetails = () => {
    if (registrationsInputDetails?.gstDetails?.gstNumber) {
      const finalData = {
        token,
        gstNumber: registrationsInputDetails?.gstDetails?.gstNumber,
      };
      dispatchGstDetailsAction(finalData);
    }
  };

  const handleRegisterUnderDetailsChange = (e: any) => {
    setRegistrationsInputDetails((prev: any) => {
      return {
        ...prev,
        registerdUnder: {
          ...prev.registerdUnder,
          [e.target.name]: e.target.value,
        },
      };
    });
  };

  useDebounce(
    () => {
      if (singleClientDirectory) {
        const finalData = {
          operation: "update",
          role: "client",
          panNumber: registrationsInputDetails?.registrationDetails?.pan,
        };
        handleClientPanUniqueCheck(finalData);
      } else {
        const finalData = {
          operation: "add",
          role: "client",
          panNumber: registrationsInputDetails?.registrationDetails?.pan,
        };
        handleClientPanUniqueCheck(finalData);
      }
    },
    500,
    [registrationsInputDetails?.registrationDetails?.pan]
  );

  useDebounce(
    () => {
      if (singleClientDirectory) {
        const finalData = {
          operation: "update",
          role: "client",
          aadhaarNumber: registrationsInputDetails?.others?.aadhaarNo,
        };
        handleClientAadharUniqueCheck(finalData);
      } else {
        const finalData = {
          operation: "add",
          role: "client",
          aadhaarNumber: registrationsInputDetails?.others?.aadhaarNo,
        };
        handleClientAadharUniqueCheck(finalData);
      }
    },
    500,
    [registrationsInputDetails?.others?.aadhaarNo]
  );

  const handleRegistrationsDetailsChange = (e: any) => {
    e.target.name === "tan" && dispatchResetTanVerifyData();
    if (e.target.name === "pan") {
      dispatchResetPanVerifyData();
      dispatchResetClientPanUniqueCheckMessage();
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            pan: e.target.value.toUpperCase(),
          },
        };
      });
    } else {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          registrationDetails: {
            ...prev.registrationDetails,
            [e.target.name]: e.target.value,
          },
        };
      });
    }
  };
  const handleLabourLawDetailsChange = (e: any) => {
    setRegistrationsInputDetails((prev: any) => {
      return {
        ...prev,
        labourLaw: {
          ...prev.labourLaw,
          [e.target.name]: e.target.value,
        },
      };
    });
  };
  const handleOtherDetailsChange = (e: any) => {
    if (e.target.name === "aadhaarNo") {
      dispatchResetClientAadharUniqueCheckMessage();
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          others: {
            ...prev.others,
            aadhaarNo: e.target.value,
          },
        };
      });
    } else {
      setRegistrationsInputDetails((prev: any) => {
        return {
          ...prev,
          others: {
            ...prev.others,
            [e.target.name]: e.target.value,
          },
        };
      });
    }
  };

  const handleCategoryOfClientChange = (data: any) => {
    setRegistrationsInputDetails((prev: any) => {
      return {
        ...prev,
        others: {
          ...prev.others,
          categoryOfClient: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };
  return (
    <div className="card">
      <RegistrationDetails
        registrationsDetails={registrationsInputDetails?.registrationDetails}
        clientAadharUniqueCheckFetching={clientAadharUniqueCheckFetching}
        clientPanUniqueCheckFetching={clientPanUniqueCheckFetching}
        clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
        clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
        handleRegistrationsDetailsChange={handleRegistrationsDetailsChange}
        isDisabled={isDisabled}
        getPanDetails={getPanDetails}
        getTanDetails={getTanDetails}
        panVerifyDetails={panVerifyDetails}
        tanVerifyDetails={tanVerifyDetails}
        singleClientDirectory={singleClientDirectory}
      />
      <GstDetails
        gstDetails={registrationsInputDetails?.gstDetails}
        handleGstDetailsChange={handleGstDetailsChange}
        getGstDetails={getGstDetails}
        success={gstSuccess}
        isDisabled={isDisabled}
      />
      <h6>REGISTERED UNDER</h6>
      <RegisteredUnder
        handleRegisterUnderDetailsChange={handleRegisterUnderDetailsChange}
        registerUnderDetails={registrationsInputDetails?.registerdUnder}
        isDisabled={isDisabled}
      />
      <h6 className="mt-3">LABOUR LAW</h6>
      <LabourLaw
        handleLabourLawDetailsChange={handleLabourLawDetailsChange}
        labourLawDetails={registrationsInputDetails?.labourLaw}
        isDisabled={isDisabled}
      />
      <h6 className="mt-3">OTHERS</h6>
      <Others
        clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
        clientAadharUniqueCheckFetching={clientAadharUniqueCheckFetching}
        handleOtherDetailsChange={handleOtherDetailsChange}
        handleCategoryOfClientChange={handleCategoryOfClientChange}
        setRegistrationsInputDetails={setRegistrationsInputDetails}
        othersDetails={registrationsInputDetails?.others}
        isDisabled={isDisabled}
      />
      <hr className="mt-5"></hr>
      <div className="row">
        <div className="col-md-12 text-right">
          <button
            className={isViewClientPresent ? "btn-primary btn" : "btn"}
            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
            onClick={() => handleGoBack()}
          >
            {" "}
            {isViewClientPresent ? "Back" : "Cancel"}
          </button>
          {!isViewClientPresent ? (
            <button
              className="btn btn-primary"
              onClick={handleClientDirectoryFormSubmit}
              disabled={
                clientPanUniqueCheckMessage?.includes(
                  "PAN number already exists"
                ) ||
                clientAadharUniqueCheckMessage?.includes(
                  "Aadhaar number already exists"
                )
              }
            >
              {singleClientDirectory ? "Save Changes" : "Save"}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
      {gstFetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  gstDetails: state.services.gstDetails,
  gstSuccess: state.services.success,
  gstFetching: state.services.fetching,
  panVerifyDetails: state.services.panVerifyDetails,
  tanVerifyDetails: state.services.tanVerifyDetails,
});
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispatchVerifyTanAction: (data: verifyTanType) =>
    dispatch(verifyTanAction(data)),
  dispatchVerifyPanAction: (data: verifyPanType) =>
    dispatch(verifyPanAction(data)),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchResetServicesSucces: () => dispatch(resetServicesSucces()),
  dispatchResetPanVerifyData: () => dispatch(resetPanVerifyData()),
  dispatchResetTanVerifyData: () => dispatch(resetTanVerifyData()),
});

export default connect(mapStateToProps, dispatchStateToProps)(RegistrationsTab);
